import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  getDocs,
  serverTimestamp,
  addDoc,
  query,
  orderBy,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDH9aTnPHNHwc7-f1T4ULusJWjYTJ8vJ0o",
  authDomain: "my-website-95798.firebaseapp.com",
  projectId: "my-website-95798",
  storageBucket: "my-website-95798.appspot.com",
  messagingSenderId: "947004413349",
  appId: "1:947004413349:web:8c80872c949222c951c44c",
};

// Init firebase app
initializeApp(firebaseConfig);

// Init service
const db = getFirestore();

// Skills and tools collection ref.
const projectsRef = collection(db, "projects");

// Queries
const q = query(projectsRef, orderBy("deployedAt", "desc"));

// const myProjectsData = [
//   {
//     image: "https://i.imgur.com/TSE3suB.png",
//     title: "Netflix Clone",
//     description:
//       "This is a Netflix clone built with angular that you can watch Netflix originals, TV Programs, choose your favorite movie and watch movies trailers.",
//     liveDemoLink: "https://netflix-clone-781da.web.app/",
//     sourceCodeLink: "https://github.com/moatefdev/Angular_Netflix_Clone",
//     techs: ["Angular"],
//   },
//   {
//     image: "https://i.imgur.com/zv1E0b4.png",
//     title: "POS",
//     description:
//       "This is a  point of sale app built with angular that you can make food order, print invoices, add your categories and products and signup as an admin or a cashier.",
//     liveDemoLink: "https://my-pos-9eb30.web.app/",
//     sourceCodeLink: "https://github.com/moatefdev/Point_Of_Sale",
//     techs: ["Angular"],
//   },
//   {
//     image: "https://i.imgur.com/1AvDH4r.png",
//     title: "Netflix Clone",
//     description:
//       "This is a Netflix clone app built with react that you can choose you favorite movie category and watch movies trailers.",
//     liveDemoLink: "https://netflix-clone-react-3bb44.web.app//",
//     sourceCodeLink: "https://github.com/moatefdev/React_Netflix_Clone",
//     techs: ["React"],
//   },
// ];

// Add documents
// const addProjects = () => {
//   myProjectsData
//     .map((project) => {
//       return addDoc(projectsRef, { ...project, createdAt: serverTimestamp() });
//     })
//     .then((res) => console.log(res));
// };
// addProjects();

// Get collection data
export let projects = [];
getDocs(q, projectsRef)
  .then((snapshot) => {
    snapshot.docs.forEach((doc) => {
      projects.push(doc.data());
    });
  })
  .catch((err) => {
    console.log(err);
  });
// console.log(projects);
